import React from "react";
import UnavailableSection from "components/UnavailableSection";

/**
 * Was rendering three hardcoded phone numbers.
 *
 * There is no way to read a contact's phone numbers today: DCR_OrgContactComplete
 * carries addressList but no phone list, and no phone-number route is exposed on
 * the API. CoreSc has Read_PhoneNumbers_Mappings_By_ContactId, so this needs an
 * endpoint exposing it (plus a read per id) before the tab can show anything.
 */
const PhoneNumbersList = () => (
  <UnavailableSection
    title="Phone numbers are not available yet"
    reason="Reading a client's phone numbers needs an API route for Read_PhoneNumbers_Mappings_By_ContactId, which is not exposed yet."
  />
);

export default PhoneNumbersList;
